module.exports = __webpack_public_path__ + "img/kid10.0f575ebe.png";